import { render, staticRenderFns } from "./schoolPath.vue?vue&type=template&id=57121633&scoped=true"
import script from "./schoolPath.vue?vue&type=script&lang=js"
export * from "./schoolPath.vue?vue&type=script&lang=js"
import style0 from "./schoolPath.vue?vue&type=style&index=0&id=57121633&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57121633",
  null
  
)

export default component.exports